import type { EmailTemplate } from '../email/index';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class EmailTemplateFactory extends ObjectFactory<EmailTemplate> {
  protected getDefaults(): EmailTemplate {
    return {
      ...baseDocumentFactory.build(),
      templateId: 'd-sendgrid-template-id',
      templateName: 'welcome-email',
    };
  }
}

export const emailTemplateFactory = new EmailTemplateFactory();
